// extracted by mini-css-extract-plugin
export default {"main":"events_main__Rgh8u","homeimage":"events_homeimage__pfyrI","upper":"events_upper__LIg3x"};